module.exports = __webpack_public_path__ + "static/img/ability2-4.73d9763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/ability2-4.jpg
// module id = xr6e
// module chunks = 3